module.exports = "data:application/octet-stream;base64,Ly8gcmVtb3ZlZCBieSBleHRyYWN0LXRleHQtd2VicGFjay1wbHVnaW4="


//////////////////
// WEBPACK FOOTER
// ./src/static/scss/App.scss
// module id = 395
// module chunks = 0